import { invalidInstantiation } from './invalid-instantiation';
import { NotEmptyStringValue } from './not-empty-string-value';
import { PreferNominal } from './prefer-nominal';
import { PrimitiveValue } from './primitive-value';

export class UrlValue extends NotEmptyStringValue {
  url: PreferNominal;

  constructor(v: string) {
    super(v);
    if (!/^http(s)?(:\/\/[-_.!~*\'()a-zA-Z0-9;\/?:\@&=+\$,%#]+)$/.test(v)) {
      throw new TypeError(invalidInstantiation);
    }
  }

  toString(): string {
    return this.value;
  }
}
